<script>
  import { onMount, createEventDispatcher } from 'svelte';

  import { getCurrentUserStore } from '@stores/current_user';
  import VisibilityGuard from '@components/VisibilityGuard.svelte';
  import PreloadBox from '@components/PreloadBox.svelte';
  import { getGroupStore } from '@stores/group';

  let groupStore = getGroupStore('groupStore');
  let recObjectsStore = getGroupStore('recObjectsStore');
  let recsStore = getGroupStore('recsStore');

  import Desktop from '@app-components/rec_object/Desktop.svelte';
  import Mobile from '@app-components/rec_object/Mobile.svelte';

  import queryString from 'query-string';
  import jQuery from 'jquery';

  import DetailViewModal from '@app-components/rec_object/detail_view/DetailViewModal.svelte';

  export let id;
  export let sectionId;
  export let mobile = false;
  export let showDetailView = true;
  export let showActionBar = true;
  export let showShareCard = true;
  export let forceShowNames = false;
  export let customGroupStore;
  export let showOnRender = false;

  const dispatch = createEventDispatcher();

  let currentUser = getCurrentUserStore('default');
  let group = customGroupStore || groupStore;
  let recObject = recObjectsStore.find(id);
  let recs = [];

  let detailId;
  let showDetailViewModal;

  $: detailViewEnabled = showDetailView && currentUser && group;

  let dispatchFullRecObjectRendered = () => {
    dispatch('rec-object-fully-rendered');
  };

  let displayRecObjectDetailView = function (event, afterDisplay) {
    if (!detailViewEnabled) {
      return;
    }

    if (event) {
      var target = jQuery(event.target);
      var sel = getSelection().toString().trim();

      if (
        sel == '' &&
        target.closest('.owl-dot').length == 0 &&
        target.closest('.owl-nav').length == 0 &&
        target.hasClass('avatar') === false
      ) {
        showDetailViewModal = true;
      }
    } else {
      showDetailViewModal = true;
    }

    if (afterDisplay) {
      setTimeout(() => {
        afterDisplay();
      }, 0);
    }
  };

  let popStateListener = function (_event) {
    let detailId = queryString.parse(location.search).detail_id;
    showDetailViewModal = detailId && recObject.id == detailId;
  };

  let setRecs = function (newRecsStore) {
    if (recObject) {
      let filter = { rec_object_id: recObject.id };

      if (sectionId) {
        filter['section_id'] = sectionId;
      }

      recs = newRecsStore.where(filter);
    }
  };

  setRecs(recsStore);

  onMount(() => {
    window.addEventListener('popstate', popStateListener);
    detailId = queryString.parse(location.search).detail_id;
    showDetailViewModal = recObject && detailId == recObject.id;

    let unsubGroup = groupStore.subscribe((x) => {
      if (x.id) {
        group = x;
      }
    });

    let unsubRecObject = recObject
      ? recObject.subscribe((x) => {
          recObject = x;

          if (x && !x.isNew) {
            dispatch('rec-object-changed');
          }
        })
      : () => {};

    let unsubRecs = recsStore.subscribe((x) => {
      setRecs(x);
    });

    return () => {
      unsubGroup();
      unsubRecObject();
      unsubRecs();
      window.removeEventListener('popstate', popStateListener);
    };
  });
</script>

{#if recObject}
  {#if detailViewEnabled && showDetailViewModal}
    <DetailViewModal
      customGroupStore={customGroupStore}
      showActionBar={showActionBar}
      showShareCard={showShareCard}
      recObjectId={recObject.id}
      bind:showModal={showDetailViewModal}
      displayRecObjectDetailView={displayRecObjectDetailView} />
  {/if}

  <VisibilityGuard let:hasBeenVisible>
    {#if showOnRender || hasBeenVisible}
      {#if mobile}
        <Mobile
          customGroupStore={customGroupStore}
          group={group}
          recObject={recObject}
          recs={recs}
          forceShowNames={forceShowNames}
          on:rec-object-fully-rendered={dispatchFullRecObjectRendered}
          detailViewEnabled={detailViewEnabled}
          displayRecObjectDetailView={displayRecObjectDetailView}
          {...$$props} />
      {:else}
        <Desktop
          customGroupStore={customGroupStore}
          group={group}
          recObject={recObject}
          recs={recs}
          forceShowNames={forceShowNames}
          on:rec-object-fully-rendered={dispatchFullRecObjectRendered}
          detailViewEnabled={detailViewEnabled}
          displayRecObjectDetailView={displayRecObjectDetailView}
          {...$$props} />
      {/if}
    {:else}
      <div
        id="grid-rec-object-{recObject.id}"
        data-rec-object-id={recObject.id}
        class={recObject.weblink_broken ? 'broken-link-rec-object' : ''}
        style="width: 380px; height: 522px; max-height: 522px; min-height: 522px;">
        {#each recs as r (r.id)}
          <div style="display: hidden" data-rec-id={r.id} data-user-id={r.user.id} />
        {/each}

        <PreloadBox />
      </div>
    {/if}
  </VisibilityGuard>
{/if}
